import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    active?: string;
    description?: string;
    name?: string;
    type?: string;
    value?: string;
    options?: number[];
    formatText?: string;
    onBlur: any;
    onCheckboxChange: any;
    register: any;
    errors: any;
    pattern: string;
    errorMessage: string;
}

const CreditSimulatorFormField: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const { register, errors } = props;
    let fieldType = "money";
    if (props.type === "money" || props.type === "dropdown" || props.type === "middleInput" || props.type === "checkbox-only") {
        fieldType = props.type;
    }
    const getObjects = props.options == null ? [] : props.options;
    const formatText = props.formatText == null ? "" : props.formatText;

    function handleToggleButtonChange(e: any, elId: string) {
        const element = document.getElementById(elId);
        if (element) {
            if (e.currentTarget.checked && element.attributes.getNamedItem("disabled") != null) {
                // enable input
                element.attributes.removeNamedItem("disabled");
            } else {
                // disable input
                const attr = document.createAttribute("disabled");
                attr.value = "disabled";
                element.attributes.setNamedItem(attr);
            }
        }
        props.onCheckboxChange(e);
    }

    return (
        <React.Fragment>
            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                <div className="form-row">
                    <div className="form-input">
                        <label className="form-toggle-label" htmlFor={`chbox_${props.name}`}>
                            <input type="checkbox" id={`chbox_${props.name}`} value={props.active} onClick={(e) => handleToggleButtonChange(e, `${props.name}`)} />
                            <span className="form-toggle-label-text">{props.description}</span>
                        </label>
                    </div>
                </div>
            </div>
            {(() => {
                if (fieldType && fieldType === "dropdown") {
                    return (
                        <div className="col-xs-12 col-sm col-no-gutter flex-grow-null col-offset-toggle">
                            <div className="form-row inline">
                                <div className="form-label">
                                    <label htmlFor={`${props.name}`} className="sr-only">
                                        Select period of days
                                    </label>
                                </div>
                                <div className="form-input">
                                    <div className="form-input-content ">
                                        <select
                                            className="inputbox disabled-on-reset"
                                            id={`${props.name}`}
                                            name={`${props.name}`}
                                            disabled={true}
                                            onBlur={props.onBlur}
                                        >
                                            {getObjects.map((option) => (
                                                <option key={option} value={option}>
                                                    {option} {formatText}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                } else if (fieldType && fieldType !== "checkbox-only") {
                    return (
                        <div className="col-xs-12 col-sm col-no-gutter flex-grow-null col-offset-toggle">
                            <div className="form-row inline">
                                {fieldType === "money" ? (
                                    <React.Fragment>
                                        <div className="form-label prefix-label">
                                            <label htmlFor={`${props.name}`}>
                                                <span className="sr-only">Enter value in </span> <abbr title="Dollar">$&nbsp;</abbr>
                                            </label>
                                        </div>
                                        <div className="form-input text-align-right ">
                                            <div className="form-input-content">
                                                <input
                                                    type="text"
                                                    ref={register({ required: true, pattern: new RegExp(props.pattern) })}
                                                    id={`${props.name}`}
                                                    name={`${props.name}`}
                                                    className="inputbox disabled-on-reset input-width-sm"
                                                    placeholder="0"
                                                    disabled={true}
                                                    size={10}
                                                    onBlur={props.onBlur}
                                                />
                                            </div>
                                            {{ ...errors[`${props.name}`] }.type === "required" && (
                                                <span className="form-error"> {tLang("creditSimulator.accountInfoSection.validationMessage.required")}</span>
                                            )}
                                            {{ ...errors[`${props.name}`] }.type === "pattern" && <span className="form-error"> {props.errorMessage} </span>}
                                        </div>
                                    </React.Fragment>
                                ) : (
                                        <div className="form-input  text-align-right">
                                            <label htmlFor={`${props.name}`} className="hide-label">
                                                <span>0</span>
                                            </label>
                                        <div className="form-input-content">
                                            <input
                                                type="text"
                                                ref={register({ required: true, pattern: new RegExp(props.pattern) })}
                                                id={`${props.name}`}
                                                name={`${props.name}`}
                                                className="inputbox disabled-on-reset"
                                                placeholder="0"
                                                disabled={true}
                                                size={10}
                                                onBlur={props.onBlur}
                                            />
                                        </div>
                                        {{ ...errors[`${props.name}`] }.type === "required" && (
                                            <span className="form-error"> {tLang("creditSimulator.accountInfoSection.validationMessage.required")}</span>
                                        )}
                                        {{ ...errors[`${props.name}`] }.type === "pattern" && <span className="form-error"> {props.errorMessage} </span>}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                }
            })()}
        </React.Fragment>
    );
};

export default CreditSimulatorFormField;
